module.exports = __webpack_public_path__ + "static/media/chrome.42d34cb0.png";